import { Component, Input } from '@angular/core';
import { ColumnsConfig, TableConfig, TableData } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceService } from '../../device/device.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { SiteDashboardService } from '../../site-dashboard.service';
import { DeviceFactory } from '../../device/device-factory/device-factory';
import { CommonService } from 'src/app/shared/services/common.service';
import { DecimalPipe } from '@angular/common';

@Component({
	selector: 'app-charger-monthly-quarterly-usage-report',
	templateUrl: './charger-monthly-quarterly-usage-report.component.html',
	styleUrls: ['./charger-monthly-quarterly-usage-report.component.css']
})
export class ChargerMonthlyQuarterlyUsageReportComponent {
	@Input() device: any = {};
	@Input() currentSite: any = {};
	@Input() studyInfo: any = {};
	allYearsId = 9999;
	yearList: any[] = [];
	selectedYear: number = new Date().getFullYear();
	usageData = {};
	siteInstallationDate = null;

	periodTypes = [
		{label: this.translate.instant('g.monthly'), id: 'monthly'},
		{label: this.translate.instant('g.quarterly'), id: 'quarterly'},
	];

	selectedPeriodType = 'monthly';

	columnConfig: ColumnsConfig[] = [
		{key: 'period', name: this.translate.instant('connectivity_verification.month'), type: 'string'},
		{key: 'total_charge_hour', name: this.translate.instant('chargers_performance.total_charge_hour'), type: 'number'},
		{key: 'total_idle_hours', name: this.translate.instant('chargers_performance.total_idle_hours'), type: 'number'},
		{key: 'total_off_time_hours', name: this.translate.instant('chargers_performance.total_off_time_hours'), type: 'number'},
		{key: 'total_charge_ah', name: this.translate.instant('chargers_performance.total_charge_ah'), type: 'number'},
		{key: 'total_charge_kwh', name: this.translate.instant('chargers_performance.total_charge_kwh'), type: 'number'},
	];

	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		hasExport: true,
		hasPagination: true,
		pageSize: 100,
		fitScreen: true,
		hideNoData: true,
		draggable: true,
		fileName: this.translate.instant('chargers_performance.monthly_quarterly_usage_report'),
		csvFileHeaderInfo: []
	};

	constructor(
		private deviceService: DeviceService,
		private translate: TranslateService,
		private siteDashboardService: SiteDashboardService,
		private commonService: CommonService,
	) {}

	ngOnInit() {
		if (this.device?.config_info?.installation_date)
			this.siteInstallationDate = moment.utc(this.device.config_info.installation_date * 1000).startOf('day').toDate();

		this.getMonthlyQuarterlyChargerUsageReport();
		const {yearList, currentYear} =  this.siteDashboardService.prepareYearsList(this.yearList, this.siteInstallationDate);
		this.yearList = yearList;
		this.yearList.unshift({label: this.translate.instant('site_performance.truck_year_all'), id: this.allYearsId});
		this.selectedYear = currentYear;
	}

	ngOnChanges(changes){
		if(changes.device && this.device)
			this.getMonthlyQuarterlyChargerUsageReport();
	}

	getMonthlyQuarterlyChargerUsageReport() {
		this.deviceService.getMonthlyQuarterlyChargerUsageReport(this.device.mac_address, this.selectedYear, DeviceFactory.types.charglink, 0, this.studyInfo.id || 0, { getAllYears: this.isAllYearsSelected() }).subscribe((res: any) => {
			if (!res.quarterly && !res.monthly)
				return;

			this.usageData = res;
			let data = this.isAllYearsSelected() ? res?.yearly || {} || {} : res?.[this.selectedPeriodType]?.[this.selectedYear] || {};
			this.updateTableData(data);

			this.tableConfig.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
				customerName: this.currentSite.customer_name,
				siteName: this.currentSite.name,
				deviceSN: this.device.serial_number,
				includeSpacing: false
			});
		});
	}

	isAllYearsSelected() {
		return this.selectedYear === this.allYearsId;
	}

	selectYear() {
		if (this.isAllYearsSelected())
			this.columnConfig[0].name = this.translate.instant('g.year');

		this.getMonthlyQuarterlyChargerUsageReport();
	}

	changePeriodType() {
		this.columnConfig[0].name = this.selectedPeriodType === 'monthly' ? this.translate.instant('connectivity_verification.month') : this.translate.instant('site.quarter');
		this.updateTableData(this.usageData?.[this.selectedPeriodType]?.[this.selectedYear] || []);
	}

	updateTableData(data) {
		const tableData = [];
		for (const period in data) {
			if (data.hasOwnProperty(period)) {
				let periodValue = this.selectedPeriodType === 'monthly' ? this.commonService.monthsText[+data[period].month - 1] : data[period].quarter;
				if (this.isAllYearsSelected())
					periodValue = data[period].year;

				tableData.push({
					month: +data[period].month,
					period: {value: periodValue},
					total_charge_hour: {value: Math.round((data[period].total_charge_second || 0) / 3600).toLocaleString()},
					total_idle_hours: {value: Math.round((data[period].total_idle_second || 0) / 3600).toLocaleString()},
					total_off_time_hours: {value: Math.round((data[period].total_off_time_second || 0) / 3600).toLocaleString()},
					total_charge_ah: {value: Math.round((data[period].total_as || 0) / 3600).toLocaleString()},
					total_charge_kwh: {value: Math.round((data[period].total_ws || 0) / (3600 * 1000)).toLocaleString()},
				});
			}
		}

		// sort by period
		tableData.sort((a, b) => { return a.month - b.month; });
		this.tableData = tableData;
	}
}
